import React, {useEffect, useState} from "react";
import FormButton from "../../../../../components/form-button";
import {useTranslation} from "react-i18next";
import CurrencyInput from "react-currency-input-field";
import associateServices from "../../../../../services";
import {toast} from "react-toastify";
import BankDropdown from "./bank-dropdown";
import {Link} from "react-router-dom";
import InstrumentIcon from "../../../../../components/instrument-icon";
import Big from "big.js";
import InputMask from "react-input-mask";
import store from "../../../../../reducers/createReducers";
import AUTHENTICATION_ACTIONS from "../../../../../actions/authentication-actions";
import WithdrawDepositToast from "../../../../../components/toast/WithdrawToast";
import stringHelper from "../../../../../helpers/string-helper";
import {decrypt, encrypt} from "../../../../../helpers/encryption";
import {useSelector} from "react-redux";
import StringHelper from "../../../../../helpers/string-helper";

const AznWithdraw = ({type, method}) => {



    const {i18n, t} = useTranslation();
    const currentLanguage = i18n.language; // Get the current language

    const [regex] = useState(new RegExp("^\\d{1,8}(\\.\\d{0," + 8 + "})?$"))
    const [step, setStep] = useState('form')
    const [disabled, setDisabled] = useState(false)
    const [loading, setLoading] = useState(false)
    const [bankList, setBankList] = useState([])

    const [instance, setInstance] = useState({
        iban: '',
        bank: '',
        amount: ''
    })

    const [error, setError] = useState('')

    const [ibanPlaceholder, setIbanPlaceholder] = useState('')


    useEffect(() => {
        if (method?.method?.service_name) {

            const holder = StringHelper.slugify(method?.method?.service_name) + '-account-no';
            setIbanPlaceholder(t(`general.${holder}`, holder))
        } else {
            setIbanPlaceholder('')
        }
    }, [method])

    useEffect(() => {
        associateServices.profile({}).then(res => setError(!res?.data?.name || !res?.data?.surname ? t('general.provide-your-name-surname-to-deposit-withdraw-try') : ''))
    }, [])

    useEffect(() => {
        if (error || !instance.iban || !instance?.amount) {
            setDisabled(true)
        } else {
            if (type === 'Fast EFT' && !instance?.bank?.bankId) {
                setDisabled(true)
            } else {
                setDisabled(false)
            }
        }
    }, [error, instance])

    useEffect(() => {
        if (method?.method?.id) {
            if (type === 'Havale' || type === 'Fast EFT' || type === 'Transfer') {
                setLoading(true)
                associateServices.getTransferBankList({
                    type: 'withdraw',
                    provider: method?.payment_provider_id,
                    method: type
                }).then(res => {
                    setBankList(res?.data || [])
                    setLoading(false)
                })
            } else {
                setBankList([])
                handleChange('bank', null)
            }
        } else {
            setBankList([])
            handleChange('bank', null)
        }
    }, [type, method?.method?.id])

    const handleChange = (type, value) => {
        if (!value)
            value = ''
        if (type === 'amount') {
            if (value === '' || regex.test(value)) {
                setInstance(prevState => ({
                    ...prevState,
                    [type]: value
                }))
            }
        } else
            setInstance(prevState => ({
                ...prevState,
                [type]: value
            }))
    }

    const handleReset = () => {
        setStep('form')
        handleChange('otp', '')
    }


    const handleWithdraw = () => {

        setLoading(true)
        associateServices.withdraw({
            ...instance,
            code: 'AZN',
            bankId: instance?.bank?.bankId,
            type: type === 'Havale' ? 'Transfer' : type,
            provider: method?.payment_provider_id,

        }).then(res => {
            if (res?.errors)
                toast.error(t(`api-notifications.${res?.errors}`))
            setLoading(false)

            if (step === 'form') {
                if (res?.data?.step === 'email' || res?.data?.step === '2factor') {
                    setStep(res?.data?.step || '')
                    handleChange('secret', res?.data?.secret)
                }
            } else {
                if (res?.status === 200) {

                    handleReset()

                    const handleUserWallets = response => store.dispatch(AUTHENTICATION_ACTIONS.setUserWallets(response?.data || []))

                    associateServices.getWallets({}).then(handleUserWallets)


                    if (res?.data === 'withdraw-request-submitted')
                        toast(<WithdrawDepositToast
                            amount={instance.amount}
                            code={'AZN'}
                            title={t(`api-notifications.${res.data}`)}
                        />)


                }
            }
        })
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter')
            handleWithdraw()
    }

    return (

        step === 'form' ?

            <div className="modal__form">


                {/*<div className="modal__drops">*/}
                {/*    <Dropdown*/}
                {/*        className="modal__wallet-dropdown modal__wallet-dropdown--double-big width-unset"*/}
                {/*        show={show}*/}
                {/*        onToggle={() => setShow(!show)}*/}
                {/*    >*/}
                {/*        <Dropdown.Toggle*/}
                {/*            className="modal__wallet-dropdown-btn"*/}
                {/*            id="modalWallet0"*/}
                {/*            aria-expanded={show}*/}
                {/*            onClick={() => setShow(!show)}*/}
                {/*            disabled={!type}*/}
                {/*        >*/}
                {/*            Provider {method?.method?.name}*/}
                {/*            <SvgIcon id={'right-down'}/>*/}
                {/*        </Dropdown.Toggle>*/}

                {/*        <Dropdown.Menu className="modal__wallet-menu width-unset"*/}
                {/*                       aria-labelledby="modalWallet0">*/}
                {/*            <ul className="modal__wallet-currencies">*/}
                {/*                {*/}
                {/*                    providers?.map(theProvider => (*/}
                {/*                        <li onClick={e => {*/}
                {/*                            setShow(false)*/}
                {/*                            setSelectedProvider(theProvider?.provider)*/}
                {/*                        }} key={theProvider?.provider?.id}>*/}
                {/*                                <span className="gapp2">*/}
                {/*                                    {theProvider?.provider?.name}*/}
                {/*                                </span>*/}
                {/*                        </li>*/}
                {/*                    ))*/}
                {/*                }*/}
                {/*            </ul>*/}
                {/*        </Dropdown.Menu>*/}
                {/*    </Dropdown>*/}

                {/*</div>*/}


                {
                    method?.method?.id &&
                    <div className="modal__drops">
                        <div className="modal__wallet-dropdown modal__wallet-dropdown--double-big width-unset">
                            <div className="selected-method-wrapper">
                                <img src={method?.logo || method?.method?.logo_light} alt=""
                                     className={`method-img-selected ${method?.method?.name}`}/>
                            </div>
                        </div>
                    </div>
                }

                <div className="modal__drops">

                    {
                        type === 'Transfer' || type === 'Havale' || type === 'Fast EFT' ?
                            <BankDropdown
                                amount={instance.amount}
                                setAmount={e => handleChange('amount', e)}
                                bankList={bankList}
                                setBank={bank => handleChange('bank', bank)}
                                bank={instance.bank}/>
                            :

                            <div className="modal__wallet-dropdown modal__wallet-dropdown--double-big width-unset">

                                <CurrencyInput
                                    decimalsLimit={2}
                                    className="form__input  "
                                    prefix={'AZN '}
                                    placeholder={t('general.amount', 'Amount')}
                                    value={instance.amount}
                                    onValueChange={e => handleChange('amount', e)}
                                    pattern="[0-9]*"
                                    inputMode="numeric"
                                />
                            </div>

                    }


                </div>

                {
                    ibanPlaceholder &&
                    <div className="modal__drops">
                        <div
                            className="form__group modal__wallet-dropdown modal__wallet-dropdown--double-big width-unset">
                            {/*<label htmlFor="" className="form__label">*/}
                            {/*    {t('general.account-no', 'Account No')}*/}
                            {/*    <b>*</b>*/}
                            {/*</label>*/}
                            <div className="form__wallet">
                                <input
                                    value={instance.iban}
                                    onChange={e => handleChange('iban', e.target.value?.replace(/[^a-zA-Z0-9\u0400-\u04FF\s]/gi, '')?.replace(/\s/g, ''))}
                                    type="text" className="form__input"
                                    placeholder={ibanPlaceholder}
                                />
                            </div>
                        </div>
                    </div>
                }


                <FormButton
                    disabled={disabled || !type}
                    loading={loading}
                    onClick={handleWithdraw}
                    label={t('general.send-request-withdraw', 'Send Request')}
                />
                {
                    error && <Link
                        to={stringHelper.getLocalizedPath(currentLanguage, '/settings?tab=verify')}
                        className="form__note error">
                        *{error}
                    </Link>
                }

                {
                    method?.min_withdraw &&
                    <p className="form__description">
                        {`${Big(method?.min_withdraw || 0).toFixed(2)} TL - ${Big(method?.max_withdraw || 0).toFixed(2)} TL`}
                    </p>
                }
            </div>
            :
            <>
                {/*// OTP CODE*/}
                <div className="form__group">
                    <label htmlFor="" className="form__label form__label--max med">
                        {t('tip.amount')} <b>*</b>
                        <span className="d-flex align-items-center gap-2">
                                    <InstrumentIcon code={'AZN'}/>
                            {Big(instance?.amount || 0).toFixed(8)}
                                    </span>
                    </label>

                </div>
                <div className="form__group">
                    <label htmlFor="" className="form__label">
                        {t(`general.enter-otp-code-${step}`)} <b>*</b>
                    </label>
                    <InputMask
                        onKeyDown={handleKeyDown}
                        mask={'999999'}
                        maskPlaceholder={null}
                        disabled={step === 'form'}
                        className="form__input"
                        value={instance.otp || ''}
                        onChange={e => handleChange('otp', e.target.value)}
                        type="text" // Set type to text
                        inputMode="numeric" // Hint for numeric keyboard
                    />
                </div>


                <FormButton onClick={handleWithdraw}
                            label={t('modals.wallet.withdraw.withdraw')}
                            disabled={loading || disabled || instance.otp?.length !== 6}
                            loading={loading}
                />


            </>

    )

}


export default AznWithdraw
